import axios from 'axios';
import { Modal } from 'antd';
import _get from 'lodash/get';
import _keysIn from 'lodash/keysIn';

import jwt_decode from 'jwt-decode';

import { firebaseSignOut } from './firebase';

import config, { Project } from 'app.config';

const { apiUrl, authUrl, project, productHeader } = config;

export const isAdminPortal = project === Project.SupplyChainManagement;

export const getProjectPrefix = (): string => {
  switch (project) {
    case Project.SupplyChainManagement:
      return 'admin';
    case Project.SuppliersManagement:
      return 'supplier';
    default:
      return '';
  }
};

export const requestHeader = {
  'Accept': 'application/json',
  'Content-Type': 'application/json; charset=utf-8',
  'X-User-Agent': productHeader,
};

export const interceptAuth = async (config) => {
  const token = localStorage.getItem('token') || '';
  if (token && config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const interceptAuthFailed = async (error) => {
  throw error;
};

const redirectLogin = async (error) => {
  // finish unauthorized api, trigger sign out redirection
  const errRes = error.response;
  if (!!errRes && errRes.status === 401) {
    Modal.warning({
      title: '憑證失效或過期, 請重新登入',
      onOk: firebaseSignOut,
      okText: '確認',
      centered: true,
    });
  }
  throw error;
};

export const reduceResponse = async (response) => {
  // if (response.status === 201) {
  //   message.success('請求成功且新的資源成功被創建!');
  // } else if (response.status === 202) {
  //   message.success('伺服器已成功接收需求!');
  // }
  return response;
};

export const authorizedRequest = (
  path,
  isAuthService?,
  options?: {
    authorizeRequest: boolean;
    authorizeResponse: boolean;
    headers?: object;
  }
) => {
  const url = isAuthService ? authUrl : apiUrl;
  const authorizeRequest = !!options ? options.authorizeRequest : true;
  const authorizeResponse = !!options ? options.authorizeResponse : true;
  const headers = !!options
    ? {
        ...requestHeader,
        ...(options.headers || {}),
      }
    : requestHeader;
  const base = axios.create({
    baseURL: `${url}${path ? `/${path}` : ''}`,
    headers: headers,
  });
  if (authorizeRequest) base.interceptors.request.use(interceptAuth, interceptAuthFailed);
  if (authorizeResponse) base.interceptors.response.use(reduceResponse, redirectLogin);
  return base;
};

export const projectRequest = (isAuthService?, customPrefix?) => {
  const auth = localStorage.token;
  const token = jwt_decode(auth);
  const key = _keysIn(token).filter((val) => /^(dss-supplier.\d+)$/.test(val))[0];
  return authorizedRequest(
    customPrefix
      ? customPrefix
      : isAuthService
      ? isAdminPortal
        ? `dss-${getProjectPrefix()}`
        : `${key}`
      : getProjectPrefix(),
    isAuthService
  );
};

export const getServiceData = (token: any) => {
  let data: any = {};
  const key = isAdminPortal
    ? `dss-${getProjectPrefix()}`
    : _keysIn(token).filter((val) => /^(dss-supplier.\d+)$/.test(val));

  // Use the first matching key for supplier, or the exact key for admin
  const actualKey = Array.isArray(key) ? key[0] : key;
  
  data = _get(token, actualKey, null);
  if (!data) {
    return null;
  }
  
  // Token now contains: {id, role_id, subservice, name, email}
  // Role details will be fetched separately from /role/me API
  data = {
    ...data,
    supplier_id: isAdminPortal ? undefined : (Array.isArray(key) ? key[0]?.split('.')[1] : undefined),
  };
  return data;
};
